import React from 'react';
import {
  WarrantyExclusivitySection as StyledWarrantyExclusivitySection,
  WarrantyExclusivityTitle,
  WarrantyExclusivityItem,
  WarrantyExclusivityText,
} from '../styles/warrantyStyles';
import CheckWarrantyIcon from '../../../../../images/icons/check-warranty.svg';

export const WarrantyExclusivitySection = () => {
  return (
    <StyledWarrantyExclusivitySection>
      <WarrantyExclusivityTitle>
        Os planos de garantia são exclusivos para:
      </WarrantyExclusivityTitle>
      <WarrantyExclusivityItem>
        <img src={CheckWarrantyIcon} alt="Check" />
        <WarrantyExclusivityText>
          Carros sem apontamentos relevantes de mecânica na vistoria InstaCarro.
        </WarrantyExclusivityText>
      </WarrantyExclusivityItem>
      <WarrantyExclusivityItem>
        <img src={CheckWarrantyIcon} alt="Check" />
        <WarrantyExclusivityText>Carros abaixo de 180.000km rodados.</WarrantyExclusivityText>
      </WarrantyExclusivityItem>
      <WarrantyExclusivityItem>
        <img src={CheckWarrantyIcon} alt="Check" />
        <WarrantyExclusivityText>Carros a partir do ano de 2012.</WarrantyExclusivityText>
      </WarrantyExclusivityItem>
    </StyledWarrantyExclusivitySection>
  );
};
